import { JAB } from '../cards/attack/jab';
import { SPARK } from '../cards/recursive/spark';
import { CALTROPS } from '../cards/trap/caltrops';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Common tier: 2×2, 2 dice. Prickly nuisance —
 * *if* the random-valid AI happens to feed Caltrops a die that turn, your next
 * attack reflects half its damage at you. A genuine coin-flip threat by
 * construction: the random rung only sometimes arms the loaded trap. Flags the
 * "traps want a deliberate AI" lesson at the bottom tier. */
export const THORN_SPRITE: EnemyTemplate = {
  id: 'thorn-sprite',
  name: 'Thorn Sprite',
  glyph: '❉', // spiked florette
  tier: 'common',
  hp: 12,
  loadout: [
    { card: CALTROPS, origin: { row: 0, col: 0 }, rotated: false },
    { card: JAB, origin: { row: 1, col: 0 }, rotated: false },
    { card: SPARK, origin: { row: 1, col: 1 }, rotated: false },
  ],
  drops: { gold: 3 },
};
